import React, { useState, useRef } from "react"
import styles from "./MessageBar.module.scss"
import { ChatModeInterface } from "../Home/Home"

const MessageBar: React.FC<{
    input: string
    setInput: React.Dispatch<React.SetStateAction<string>>
    disabled?: boolean
    chatMode: string
    setChatMode: React.Dispatch<React.SetStateAction<ChatModeInterface["chatMode"]>>
    callback?: (input: string) => void
}> = ({ input, setInput, disabled, chatMode, setChatMode, callback }) => {
    const [popupOpen, setPopupOpen] = useState(null as { x: number; y: number } | null)

    return (
        <div className={styles.MessageBar} onClick={() => setPopupOpen(null)}>
            <input
                disabled={disabled}
                value={input}
                type="text"
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault()
                        if (input.trim()) {
                            if (callback) {
                                callback(input.trim())
                            }
                            setInput("")
                        }
                    }
                }}
                className={styles.input}
                placeholder={"Send a message..."}
            />
            <div className={styles.actions}>
                <div className="flex">
                    <div
                        className={styles.button}
                        onClick={(e) => {
                            e.stopPropagation()
                            const x = e.clientX
                            const y = e.clientY
                            const offset = 200
                            const adjustedX =
                                x < offset
                                    ? offset
                                    : x > window.innerWidth - offset
                                    ? window.innerWidth - offset
                                    : x
                            const adjustedY =
                                y < offset
                                    ? offset
                                    : y > window.innerHeight - offset
                                    ? window.innerHeight - offset
                                    : y
                            setPopupOpen(!popupOpen ? { x: adjustedX, y: adjustedY } : null)
                        }}>
                        <i className="material-symbols-rounded">discover_tune</i>
                        Options
                    </div>
                    {chatMode && (
                        <div
                            className={styles.button}
                            style={{
                                background: "var(--theme)",
                                color: "#fff",
                            }}
                            onClick={() => setChatMode("")}>
                            <i className="material-symbols-rounded">close</i>
                            {chatMode}
                        </div>
                    )}
                </div>
                <div
                    style={{
                        background: input ? "var(--theme)" : undefined,
                        color: input ? "#fff" : undefined,
                    }}
                    className={styles.send}
                    onClick={() => {
                        if (input.trim()) {
                            if (callback) {
                                callback(input.trim())
                            }
                            setInput("")
                        }
                    }}>
                    <i className="material-symbols-rounded">arrow_upward_alt</i>
                </div>
            </div>
            {popupOpen && (
                <div
                    className={styles.popup}
                    style={{
                        left: popupOpen.x - 20,
                        top: popupOpen.y - 20,
                    }}
                    onMouseLeave={() => setPopupOpen(null)}>
                    <div
                        className={styles.item}
                        onClick={() => {
                            setPopupOpen(null)
                            setChatMode("")
                        }}>
                        <i className="material-symbols-rounded">live_help</i> Ask Pretzel or the LLM
                    </div>
                    <div
                        className={styles.item}
                        onClick={() => {
                            setPopupOpen(null)
                            setChatMode("asking all files")
                        }}>
                        <i className="material-symbols-rounded">quick_reference_all</i> Ask your
                        files (RAG)
                    </div>
                    <div
                        className={styles.item}
                        onClick={() => {
                            setPopupOpen(null)
                            setChatMode("asking open file")
                        }}>
                        <i className="material-symbols-rounded">file_open</i> Ask open file (RAG)
                    </div>
                    <div
                        className={styles.item}
                        onClick={() => {
                            setPopupOpen(null)
                            setChatMode("asking the web")
                        }}>
                        <i className="material-symbols-rounded">globe</i> Ask the web
                    </div>
                    <div
                        className={styles.item}
                        onClick={() => {
                            setPopupOpen(null)
                            setChatMode("web search only")
                        }}>
                        <i className="material-symbols-rounded">travel_explore</i> Web search only
                    </div>
                </div>
            )}
        </div>
    )
}

export default MessageBar
